import circleCheck2 from "@/assets/icons/circle-check-2.svg";
import { Card, CardContent } from "@/components/ui/card";
import {
  useGeneralConfigActions,
  useGeneralConfigShouldShowWelcomeAlert,
} from "@/store/general-config.store";
import { CloseCircle } from "iconsax-react";
import { AnimatePresence, motion } from "motion/react";
import { FC, HTMLAttributes } from "react";

type WelcomeAlertProps = HTMLAttributes<HTMLDivElement>;

const WelcomeAlert: FC<WelcomeAlertProps> = (props) => {
  const show = useGeneralConfigShouldShowWelcomeAlert();

  const { setShouldShowWelcomeAlert: setShow } = useGeneralConfigActions();

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ height: 0, translateY: -10, opacity: 0 }}
          animate={{
            height: show ? "auto" : 0,
            translateY: 0,
            opacity: 1,
          }}
          exit={{ height: 0, translateY: -10, opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <Card className={props.className}>
            <CardContent className="pt-4">
              <div className="flex items-start gap-4">
                <div className="shrink-0">
                  <img
                    src={circleCheck2}
                    width={20}
                    height={20}
                    className="inline-block"
                  />
                </div>

                <div className="flex grow flex-col gap-2 text-[#293038]">
                  <div className="flex shrink-0">
                    <h3 className="grow text-lg">¡Te damos la bienvenida!</h3>

                    <CloseCircle
                      className="shrink-0 cursor-pointer"
                      size={24}
                      onClick={() => setShow(false)}
                    />
                  </div>

                  <p className="text-sm leading-relaxed">
                    Desde aquí podrás gestionar y completar la información
                    necesaria para avanzar en tu evaluación hacia el distintivo.
                    Recuerda que este es un espacio diseñado para facilitar tu
                    camino hacia la sostenibilidad. Si necesitas ayuda en algún
                    momento, estamos aquí para apoyarte.
                  </p>
                  <p className="text-sm">
                    <strong>
                      ¡Gracias por ser parte del cambio hacia un futuro más
                      sostenible! 🌿
                    </strong>
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default WelcomeAlert;
